export default "__VITE_ASSET__BmogPIY0__"